export default "__VITE_ASSET__BrRvXMEQ__"